import styled from "styled-components"
import Icon from "gatsby-theme-blank/src/components/Icon/icon"

const AdditionalInfos = styled.section`
  background-color: ${(props) => props.theme.a_color_gradients.a_medium};
  color: ${(props) => props.theme.c_color_gradients.c_dark};
`
const AdressTitle = styled.h1`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
  & ~ div {
    color: ${(props) => props.theme.c_color_gradients.c_dark};
  }
`
const Separator = styled.hr`
  &::after {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
`
const AdressPlaceIcon = styled(Icon)`
  color: ${(props) => props.theme.b_color_gradients.b_dark};
`
const AdressPlaceTitle = styled.p`
  color: ${(props) => props.theme.b_color_gradients.b_dark};
`
const AdressFooterContainer = styled.div`
  color: ${(props) => props.theme.c_color_gradients.c_medium};
`

export {
  AdditionalInfos,
  AdressTitle,
  Separator,
  AdressPlaceIcon,
  AdressPlaceTitle,
  AdressFooterContainer,
}
